var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, ObjectType } from "type-graphql";
import { Node } from "../relay.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { TimestampedResource } from "./Resource.js";
let MarathonHourNode = class MarathonHourNode extends TimestampedResource {
    id;
    title;
    details;
    shownStartingAt;
    durationInfo;
    text() {
        return this.title;
    }
    static init({ id, title, details, shownStartingAt, durationInfo, createdAt, updatedAt, }) {
        return this.createInstance().withValues({
            id,
            title,
            details,
            shownStartingAt,
            durationInfo,
            createdAt,
            updatedAt,
        });
    }
    getUniqueId() {
        return this.id.id;
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], MarathonHourNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], MarathonHourNode.prototype, "title", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], MarathonHourNode.prototype, "details", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: false }),
    __metadata("design:type", Function)
], MarathonHourNode.prototype, "shownStartingAt", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], MarathonHourNode.prototype, "durationInfo", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], MarathonHourNode.prototype, "text", null);
MarathonHourNode = __decorate([
    ObjectType({
        implements: [Node],
    })
], MarathonHourNode);
export { MarathonHourNode };
//# sourceMappingURL=MarathonHour.js.map